import { isDefined } from "@clipboard-health/util-ts";
import { get } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import {
  type GetShiftBoostsResponse,
  GetShiftBoostsResponseSchema,
  type ShiftBoostStatus,
} from "@src/appV2/redesign/Shift/ShiftBoost/api/schema";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";

interface GetShiftBoostParams {
  workerId: string;
  statuses: ShiftBoostStatus[];
  shiftId?: string;
}

export function useGetShiftBoosts(
  params: GetShiftBoostParams,
  options: UseQueryOptions<GetShiftBoostsResponse> = {}
): UseQueryResult<GetShiftBoostsResponse> {
  const { workerId, statuses, shiftId } = params;

  return useQuery<GetShiftBoostsResponse>({
    queryKey: ["shiftBoosts", workerId, statuses, shiftId],
    queryFn: async () => {
      const { data } = await get({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/shift-boosts`,
        responseSchema: GetShiftBoostsResponseSchema,
        queryParams: {
          filter: {
            status: statuses.join(","),
            ...(isDefined(shiftId) && { "shift.id": shiftId }),
          },
        },
      });

      return data;
    },
    enabled: isDefined(workerId),
    ...options,
  });
}
